import {DUET_SESSIONS_PER_PERIOD} from '../../../lib/constants/duet';

/**
 * Features for various Exponent products, to be used with PlanCard
 */
export const freeFeatures = [
  {
    label: 'Sample lessons',
    tooltip: 'Get a taste of what Exponent has to offer',
  },
  {
    label: `${DUET_SESSIONS_PER_PERIOD} peer mocks per month`,
    tooltip: 'Schedule mock interviews with peers',
  },
  {
    label: 'Sample questions',
    tooltip: 'Limited access to the most up-to-date database of real interview questions',
  },
  {
    label: 'Basic job referrals',
    tooltip: 'Get more interviews with access to our network of referrers at top companies',
  },
];

export const membershipFeatures = [
  {
    label: 'All courses',
    tooltip: 'Get access to our entire course catalog for interviews and career skills',
  },
  {
    label: 'Video and written solutions',
    tooltip: 'Watch real interviewers answer questions and give in-depth career talks in our premium video content',
  },
  {
    label: 'Unlimited peer mocks',
    tooltip: 'Schedule unlimited mock interviews with peers',
  },
  {
    label: 'AI interview feedback',
    tooltip: 'Get feedback for your peer mocks from an AI observer trained on our curriculum',
  },
  {
    label: 'AI mock interviews',
    tooltip: 'Get feedback from an AI interviewer trained on our curriculum',
  },
  {
    label: 'Full question database',
    tooltip: 'Access the most up-to-date database of real interview questions and discuss with the community',
  },
  {
    label: 'Priority job referrals',
    tooltip: 'Get more interviews with unlimited priority access to our network of referrers at top companies',
  },
  {
    label: 'Slack community',
    tooltip: 'Join a private members-only community to discuss interviewing tips, strategies, and find study buddies',
  },
];

export const resumeReviewFeatures = [
  {
    label: 'Reviewed by senior tech recruiters & hiring managers',
  },
  {
    label: 'Get review in 5 business days or less',
  },
  {
    label: 'Money-back guarantee',
    tooltip: 'Full refund if not satisfied',
  },
];

export const resumeReviewCallFeatures = [
  {
    label: '1-on-1 session with a senior tech recruiter / hiring manager',
  },
  {
    label: 'Schedule anytime',
    tooltip: 'Book a session after purchase',
  },
  {
    label: 'Money-back guarantee',
    tooltip: 'Full refund if not satisfied',
  },
];
